export default __webpack_public_path__ + "static/logocontours-80dbf10a40d28aab853d21f538518adb.png";